module.exports = __webpack_public_path__ + "images/favicon-32x32.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/favicon-32x32.png
// module id = 232
// module chunks = 0